import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../constants';
import { FormGenerator } from '../../helper/FormGenerator';
import { useTokens } from '../../context/TokenContext';
import { countryOptions, stateOptions } from '../../utils/appUtils';

const EditBankInfo = ({ vendorData, onReload }) => {
    const { getItem } = useTokens();
    const authToken = getItem('vendor', 'AuthToken');  // Use token from context
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        if (vendorData) {
            // Map API response to form fields
            const mappedData = {
                accountHolderName: vendorData.accountHolderName || '',
                bankName: vendorData.bankName || '',
                accountNumber: vendorData.accountNumber || '',
                confirmAccountNumber: vendorData.confirmAccountNumber || '',
                ifscCode: vendorData.ifscCode || '',
                branchName: vendorData.branchName || '',
                upiId: vendorData.upiId || ''
            };
            setFormData(mappedData);
            setUserData(vendorData);
        }
    }, [vendorData]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const toastId = toast.loading('Saving your settings...', { autoClose: false });

        // Validate required fields
        if (!formData.accountHolderName || !formData.bankName || !formData.accountNumber || !formData.ifscCode) {
            toast.update(toastId, {
                render: 'Please fill out all required fields.',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            });
            setLoading(false);
            return;
        }

        try {
            const response = await axios.put(`${API_URL}/vendor/update`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                toast.update(toastId, {
                    render: 'Settings saved successfully!',
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000,
                });
                setUserData(formData); // Update user data
                if (onReload) onReload(); // Reload parent data
            }
        } catch (error) {
            toast.update(toastId, {
                render: 'Failed to save settings. Please try again.',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return (
        loading ? (
            <div className="loading-spinner text-center">
                <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                Loading...
            </div>
        ) : (
            <div>
                <h2>Edit Bank Info</h2>
                {/* Bootstrap Form */}
                < form onSubmit={handleFormSubmit}>

                    <div className='row'>
                        {/* Profile Picture Input using FormGenerator */}
                        <FormGenerator
                            fields={[
                                { id: 'accountHolderName', label: 'Account Holder Name', type: 'text', class: 'col-md-6', required: true },
                                { id: 'bankName', label: 'Bank Name', type: 'text', class: 'col-md-6', required: true },
                                { id: 'accountNumber', label: 'Account Number', type: 'text', class: 'col-md-6', required: true, isNumeric: true },
                                { id: 'confirmAccountNumber', label: 'Confirm Account Number', type: 'text', class: 'col-md-6', required: true, isNumeric: true },
                                { id: 'ifscCode', label: 'IFSC Code', type: 'text', class: 'col-md-6', required: true },
                                { id: 'branchName', label: 'Branch Name', type: 'text', required: true, class: 'col-md-6' },
                                { id: 'upiId', label: 'UPI ID', type: 'text', required: true, class: 'col-md-6' },
                            ]}
                            fieldData={formData}
                            onChange={(field, value) => handleInputChange({ target: { name: field, value } })}
                            hTure={false}
                            authToken={authToken}
                        />
                    </div>

                    {/* Save Settings Button */}
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Saving...' : 'Save Settings'}
                    </button>
                </form>
            </div >

        )
    );
};

export default EditBankInfo;
